module.exports = __webpack_public_path__ + "img/18ne.0e5f150d.svg";